import { PermissionScope } from 'dashboard/components/PermissionsTable/constants';
import { DataSectionData } from 'dashboard/components/PermissionsTable/DataSectionData';
import { DevelopmentSectionData } from 'dashboard/components/PermissionsTable/DevelopmentSectionData';
import { ProductsSectionData } from 'dashboard/components/PermissionsTable/ProductsSectionData';
import { Permission } from 'lib/permissions';

export const REDACTION_PERMISSION_NAMES: Permission[] = [
  Permission.AccountRedact,
  Permission.CaseRedact,
  Permission.InquiryRedact,
  Permission.TransactionRedact,
  Permission.ReportRedact,
  Permission.VerificationRedact,
];

export const EXPORT_PERMISSION_NAMES: Permission[] = [
  Permission.AccountsExport,
  Permission.CasesExport,
  Permission.GraphsExport,
  Permission.InquiriesExport,
  Permission.ReportExport,
  Permission.TransactionsExport,
];

export const PERMISSIONS_WITH_ENVIRONMENT = [
  ...REDACTION_PERMISSION_NAMES,
  ...EXPORT_PERMISSION_NAMES,
  Permission.EnvironmentView,
  Permission.CaseAllView,
  ...ProductsSectionData.sections
    .flatMap((s) => s.subSections)
    .flatMap((s) => s.rows)
    .flatMap((r) => r.actions)
    .flatMap((a) => a.permissions)
    .filter((sp) => sp.scopes.includes(PermissionScope.Environment))
    .map((sp) => sp.permission),
  ...DataSectionData.sections
    .flatMap((s) => s.subSections)
    .flatMap((s) => s.rows)
    .flatMap((r) => r.actions)
    .flatMap((a) => a.permissions)
    .filter((sp) => sp.scopes.includes(PermissionScope.Environment))
    .map((sp) => sp.permission),
  ...DevelopmentSectionData.sections
    .flatMap((s) => s.subSections)
    .flatMap((s) => s.rows)
    .flatMap((r) => r.actions)
    .flatMap((a) => a.permissions)
    .filter((sp) => sp.scopes.includes(PermissionScope.Environment))
    .map((sp) => sp.permission),
];
